import { useSelector } from "react-redux";
import LeadMedia from "../LeadMedia/component";
import StoryBodyDetail from "../StoryBodyDetail/component";
import Highlights from "../Highlights/component";
import MediaEmbed from "../../../../components/MediaEmbed/component";

import { isValidString } from "../../../../utils/content/library";
import EngagementWidgets from "../EngagementWidgets/component";
import { withSuspensefulErrorBoundary } from "../../../../components/SuspensefulErrorBoundary/component";

const Story = ({ noAds }) => {
    const content = useSelector((state) => state.detail.content);
    const audio = useSelector(
        (state) => state.detail.leadSegmentOrEpisodeAudio
    );

    const highlightListing = content.highlights?.bullets;
    const isValidAudioClipId = isValidString(audio?.clipID);
    const shouldShowHighlights =
        Array.isArray(highlightListing) && highlightListing.length > 0;

    return (
        <div data-testid="storyWrapper" data-cy="storyWrapper">
            <LeadMedia />
            {!noAds && (
                <EngagementWidgets
                    storyId={content.id}
                    isPreview={content.isPreview}
                />
            )}
            {!noAds && isValidAudioClipId && (
                <MediaEmbed
                    {...audio}
                    isLead={true}
                    autoPlay={false}
                    forcePersistence={true}
                    showcaption={false}
                    position={1}
                />
            )}
            {!noAds && shouldShowHighlights && (
                <Highlights list={highlightListing} />
            )}
            <StoryBodyDetail noAds={noAds} />
        </div>
    );
};

const SafeStory = withSuspensefulErrorBoundary(Story);

export default SafeStory;
